/**
 * SkillDelivery Platform — WMS Showcase
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 * PROPRIETARY AND CONFIDENTIAL
 *
 * Content authored by Lalit Ratwani, drawing from 22+ years of
 * Manhattan WMS implementation practice (2003-2026).
 *
 * Lightweight "In Development" card for the WMS simulation showcase.
 * Used for scenarios that exist in showcase_simulations but have no
 * video_url yet — title, description, and an "In Development" pill.
 * Visually subdued vs. the live SimulationPlayer card so the page
 * reads as "one live, several upcoming".
 */

import React from 'react';

const RoadmapCard = ({ simulation: sim }) => (
  <div className="flex flex-col bg-slate-50 border border-slate-200 rounded-brandCard p-5 transition-colors duration-200 hover:border-slate-300">
    <div className="mb-3">
      <span className="inline-block rounded-full px-3 py-1 text-xs font-medium bg-blue-50 text-blue-700">
        In Development
      </span>
    </div>

    <h3 className="text-lg font-medium text-brand-text leading-snug">
      {sim.title}
    </h3>

    {sim.description && (
      <p className="mt-2 text-sm text-slate-600 leading-relaxed line-clamp-3">
        {sim.description}
      </p>
    )}
  </div>
);

export default RoadmapCard;
